import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=f8f3178e&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts&"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=f8f3178e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f3178e",
  null
  
)

export default component.exports